export const STAGES = ["Intake", "Assigned", "Scheduled", "Report uploaded", "TAG review", "Released to school", "Billed"];
const SHORT = { "Report uploaded": "Report", "TAG review": "Your review", "Released to school": "Released" };

export const StageBar = ({ stageIndex, stage, compact = false, testId }) => {
  const closed = stage === "Closed";
  return (
    <div className={`stage-bar ${compact ? "compact" : ""} ${closed ? "closed" : ""}`} data-testid={testId || "stage-bar"} aria-label={`Stage: ${stage}`}>
      {STAGES.map((label, index) => {
        const state = closed ? "off" : stageIndex === null || stageIndex === undefined ? "off" : index < stageIndex ? "done" : index === stageIndex ? "current" : "off";
        return (
          <span key={label} className={`stage-seg ${state}`} title={label}>
            {!compact && <small>{SHORT[label] || label}</small>}
          </span>
        );
      })}
    </div>
  );
};
